import { Checkbox as MuiCheckbox } from "@mui/material";
import {
  type ChangeEventHandler,
  type FocusEventHandler,
  type Ref,
} from "react";

export type CheckboxProps = {
  checked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  size?: "small" | "medium";
  disablePadding?: boolean;
  density?: "default" | "compact";
  id?: string;
  value?: string | number | boolean;
  name?: string;
  ref?: Ref<HTMLButtonElement>;
};

export function Checkbox({
  disablePadding = false,
  density = "default",
  onBlur,
  ref,
  ...props
}: CheckboxProps) {
  const paddingSx = disablePadding
    ? 0
    : density === "compact"
      ? "6px"
      : undefined;

  return (
    <MuiCheckbox
      {...props}
      onBlur={onBlur}
      ref={ref}
      sx={paddingSx === undefined ? undefined : { p: paddingSx }}
    />
  );
}
